import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {IntMultiTagFilterSelectComponent} from "./int-multi-tag-filter-select.component";
import {IntMultiTagSelectModule} from '../int-multi-tag-select'
import {IntMultiTagFilterSelectControlComponent} from "./int-multi-tag-filter-select-control.component";
import {IntDefaultInputModule} from "../int-default-input";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IntMultiTagSelectModule,
    IntDefaultInputModule
  ],
  declarations: [
    IntMultiTagFilterSelectComponent,
    IntMultiTagFilterSelectControlComponent
  ],
  exports: [
    IntMultiTagFilterSelectComponent,
    IntMultiTagFilterSelectControlComponent
  ]
})
export class IntMultiTagFilterSelectModule {}
